module.exports = __webpack_public_path__ + "img/bg-title-1x.8f9cc269.png";